import {
  GetDashboardMenuPlugins,
  GetDashboardPlugins,
  GetHostContainer,
  HostContainerExtension,
} from '../model';

export function getHostContainerCompat(
  getDashboardMenuPlugins: GetDashboardMenuPlugins,
  getDashboardPlugins: GetDashboardPlugins,
): GetHostContainer {
  return (containerId: string) => ({
    getExtensions: () => {
      const extensions: HostContainerExtension[] = [];

      try {
        const dashboardMenuPlugins = getDashboardMenuPlugins(containerId).map(
          (item) => ({
            ...item,
            componentId: item.id,
            menuItem: {
              IconComponent: item.IconComponent,
              IconSmallComponent: item.IconSmallComponent,
              structuredAction: item.action,
              subtitle: item.subtitle,
            },
          }),
        ) as HostContainerExtension[];
        extensions.push(...dashboardMenuPlugins);
      } catch (error) {}

      try {
        const dashboardPlugins = getDashboardPlugins(containerId).map(
          (item) => ({
            ...item,
            componentId: item.id,
            Extension: item.Component,
          }),
        ) as HostContainerExtension[];
        extensions.push(...dashboardPlugins);
      } catch (error) {}

      return extensions;
    },
  });
}
